import { render, staticRenderFns } from "./MoleculeAccessDenied.vue?vue&type=template&id=530d18ee&"
import script from "./MoleculeAccessDenied.vue?vue&type=script&lang=js&"
export * from "./MoleculeAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports